import { useState } from 'react';
import { useSeiBalance } from '@hooks';
import { useWallet } from '@/contexts/WalletContext';
import { SessionExpiredModal } from './modals';

export const SessionExpiredHandler = () => {
  const { isSessionExpired } = useSeiBalance();
  const { logout } = useWallet();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      logout();
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <SessionExpiredModal
      isOpen={isSessionExpired}
      onLogout={handleLogout}
      isLoggingOut={isLoggingOut}
    />
  );
};
